import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
    auth: {
        clientId: '7ec39c4f-a170-48ed-a060-3cb3ae321857',
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: window.location.origin,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
};

export const loginRequest = {
    scopes: ['openid', 'profile', 'email'],
};

let msalInstance = null;
let initPromise = null;
let _redirectResult = null;
let _redirectConsumed = false;

export async function getMsalInstance() {
    if (!msalInstance) {
        msalInstance = new PublicClientApplication(msalConfig);
        initPromise = msalInstance.initialize()
            .then(() => msalInstance.handleRedirectPromise())
            .then(result => { _redirectResult = result; });
    }
    await initPromise;
    return msalInstance;
}

// Returns the Microsoft redirect result exactly once, then null forever.
export function consumeRedirectResult() {
    if (_redirectConsumed) return null;
    _redirectConsumed = true;
    return _redirectResult;
}